"use client"

import { useEffect, useRef } from 'react'
import { useSearchParams } from 'next/navigation'
import { toolNavigationAnalytics } from '@/lib/analytics'

export function useFromTool(currentToolId: string) {
  const searchParams = useSearchParams()
  const firedRef = useRef(false)

  useEffect(() => {
    if (firedRef.current) return
    const fromTool = searchParams.get('fromTool')
    if (!fromTool) return
    firedRef.current = true
    toolNavigationAnalytics.referredVisit({
      targetTool: currentToolId,
      fromTool,
    })
  }, [searchParams, currentToolId])
}
